export const LIABILITY_SOURCE_MAP: { [key: string]: { description: string; canRefresh: boolean; icon: string } } = {
  EMAIL: {
    canRefresh: false,
    description: 'Połączenie ze skrzynką e-mail',
    icon: 'alternate_email',
  },
  EMAIL_FORWARD: {
    canRefresh: false,
    description: 'E-mail',
    icon: 'forward_to_inbox',
  },
  MANUAL_SCANNING: {
    canRefresh: false,
    description: 'Zdjęcie, plik',
    icon: 'forward_to_inbox',
  },
  MANUAL: {
    canRefresh: false,
    description: 'Dodawanie opłat ręcznie',
    icon: 'touch_app',
  },
  PAY_BY_LINK: {
    canRefresh: false,
    description: 'Połączenie z systemem BillTech',
    icon: 'settings_ethernet',
  },
  USERPANEL_SCRAPER: {
    canRefresh: true,
    description: 'Połączenie z systemem dostawcy (eBOK)',
    icon: 'link',
  },
  DELEGATED: {
    canRefresh: false,
    description: '',
    icon: 'forward',
  },
  TOP_UP: {
    canRefresh: false,
    description: 'Doładowanie telefonu',
    icon: null,
  },
};
